import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getFeatureDataSourceFilters } from "../../../ducks/showFeature/selectors";
import { setFeatureDataSourceFilters } from "../../../ducks/showFeature/showFeature";
import { SelectedFilters } from "../types";

export const useFeatureDataSourceFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelector(getFeatureDataSourceFilters);

  const changeFilters = useCallback(
    (newFilters: SelectedFilters) => {
      dispatch(setFeatureDataSourceFilters({ ...filters, ...newFilters }));
    },
    [dispatch, filters],
  );

  return [filters, changeFilters] as const;
};
